<template>
  <gc-modal condition="true" @cancel="$emit('cancel')" modal-class="gc-modal--wide">
    <template slot="messageTitle"> Add experience </template>

    <template slot="body">
      <form ref="form">
        <div class="form-row">
          <div class="form-row__item" :class="{ field_with_errors: errors.company }">
            <label class="form-row__label">Company</label>
            <input
              type="text"
              v-model="workplace.company"
              class="title-input-small title-input--border"
              :maxlength="companyMaxLength"
              placeholder="Ex: Siemens PLM Software"
            />
            <div v-if="errors.company" class="form-row__error">{{ errors.company }}</div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-row__item" :class="{ field_with_errors: errors.title }">
            <label class="form-row__label">Position</label>
            <input
              type="text"
              v-model="workplace.title"
              class="title-input-small title-input--border"
              :maxlength="titleMaxLength"
              placeholder="Ex: Mechanical Engineer"
            />
            <div v-if="errors.title" class="form-row__error">{{ errors.title }}</div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-row__item">
            <label class="form-row__label">Start time</label>
            <div class="form-row__datetime">
              <div class="form-row__datetime--item" :class="{ field_with_errors: errors.start_month }">
                <select class="input-select" v-model="workplace.start_year">
                  <option :value="null">Year</option>
                  <option v-for="(year, index) in years" :value="year" :key="index">{{ year }}</option>
                </select>
                <div v-if="errors.start_year" class="form-row__error">{{ errors.start_year }}</div>
              </div>
              <div class="form-row__datetime--item" :class="{ field_with_errors: errors.start_month }">
                <select class="input-select" v-model="workplace.start_month">
                  <option :value="null">Month</option>
                  <option v-for="(month, index) in months" :value="index + 1" :key="index">{{ month }}</option>
                </select>
                <div v-if="errors.start_month" class="form-row__error">{{ errors.start_month }}</div>
              </div>
            </div>
          </div>
          <div class="form-row__item">
            <label class="form-row__label">End time</label>
            <div class="form-row__datetime">
              <div class="form-row__datetime--item" :class="{ field_with_errors: errors.end_year }">
                <select
                  class="input-select"
                  v-model="workplace.end_year"
                  :disabled="workplace.current"
                >
                  <option :value="null">Year</option>
                  <option v-for="(year, index) in years" :value="year" :key="index">{{ year }}</option>
                </select>
                <div v-if="errors.end_year" class="form-row__error">{{ errors.end_year }}</div>
              </div>
              <div class="form-row__datetime--item" :class="{ field_with_errors: errors.end_month }">
                <select
                  class="input-select"
                  v-model="workplace.end_month"
                  :disabled="workplace.current"
                >
                  <option :value="null">Month</option>
                  <option v-for="(month, index) in months" :value="index + 1" :key="index">{{ month }}</option>
                </select>
                <div v-if="errors.end_month" class="form-row__error">{{ errors.end_month }}</div>
              </div>
            </div>

            <label class="checkbox-label">
              <input
                class="checkbox-label__checkbox"
                v-model="workplace.current"
                type="checkbox"
              />
              I currently work here
            </label>
          </div>
        </div>

        <div class="form-row">
          <div class="form-row__item" :class="{ field_with_errors: errors.description }">
            <label class="form-row__label">Description</label>
            <textarea
              v-model="workplace.description"
              :maxlength="descriptionMaxLength"
              spellcheck="true"
              class="description-input description-input--xs"
            ></textarea>
            <div v-if="errors.description" class="form-row__error">{{ errors.description }}</div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button class="gc-modal__delete btn" @click="remove" v-if="workplace.id">
        <i class="fas fa-times-circle color-red"></i> Delete
      </button>
      <a class="gc-modal__cancel" @click.prevent="$emit('cancel')">Cancel</a>
      <button class="btn btnRed" @click.prevent="save">Save</button>
    </template>
  </gc-modal>
</template>

<script>
import axios from "axios";
import formValidationService from "@/services/formValidationService";

export default {
  name: "WorkplaceModal",
  props: ["modalParams"],
  data() {
    return {
      workplace: {
        current: true,
        end_year: null,
        end_month: null,
        start_year: null,
        start_month: null,
      },
      companyMaxLength: Grabcad.AttributeLimits.Generic.ORGANISATION_NAME,
      titleMaxLength: Grabcad.AttributeLimits.Generic.TITLE,
      descriptionMaxLength: Grabcad.AttributeLimits.Generic.CONTENT_DESCRIPTION_LONG,
      errors: {},
    };
  },
  created() {
    this.years = Grabcad.store.years;
    this.years_to = Grabcad.store.years_to;
    this.months = Grabcad.store.months;
    this.workplaces = Grabcad.store.workplaces;
    let workplace = this.modalParams.workplace;

    if (workplace) {
      this.workplace = {
        id: workplace.id,
        title: workplace.title,
        company: workplace.company,
        end_year: workplace.end_year,
        end_month: workplace.end_month,
        start_year: workplace.start_year,
        start_month: workplace.start_month,
        description: workplace.description,
        current: !workplace.end_year,
      };
    }
  },
  computed: {
    requestMethod() {
      return this.workplace.id ? "put" : "post";
    },
    workplaceIds() {
      return this.workplaces.map(function (w) {
        return w.id;
      });
    },
    selected() {
      return this.workplaceIds.indexOf(this.workplace.id);
    },
  },
  watch: {
    "workplace.current"(value) {
      if (value) {
        this.workplace.end_year = null;
        this.workplace.end_month = null;
      }
    },
  },
  methods: {
    validateForm() {
      this.errors = {};
      const fieldsToValidate = [
        { value: this.workplace.company, field: "company", label: "Company", required: true },
        { value: this.workplace.title, field: "title", label: "Position", required: true },
        { value: this.workplace.start_year, field: "start_year", label: "Start year", required: true },
        { value: this.workplace.start_month, field: "start_month", label: "Start month", required: true },
        { value: this.workplace.description, field: "description", label: "Description" },
      ];

      if (!this.workplace.current) {
        fieldsToValidate.push({ value: this.workplace.end_year, field: "end_year", label: "End year", required: true });
        fieldsToValidate.push({ value: this.workplace.end_year, field: "end_month", label: "End month", required: true });
      }

      return formValidationService.validateForm(fieldsToValidate, this.errors);
    },
    save() {
      let vm = this;
      if (!vm.validateForm()) return;

      axios
        .request("/profile/workplaces", {
          method: this.requestMethod,
          params: { id: vm.workplace.id },
          data: { workplace: vm.workplace },
        })
        .then(function (resp) {
          Array.prototype.splice.call(vm.workplaces, 0);
          Array.prototype.push.apply(vm.workplaces, resp.data);
          vm.$emit("cancel");
          vm.showUpdated();
        })
        .catch(function () {
          vm.$emit("cancel");
          vm.showError("Failed to save workplace!");
        });
    },
    remove() {
      let vm = this;
      axios
        .request("/profile/workplaces", {
          method: "delete",
          params: { id: this.workplace.id },
        })
        .then(function () {
          vm.workplaces.splice(vm.selected, 1);
          vm.$emit("cancel");
          vm.showRemoved();
        })
        .catch(function () {
          vm.$emit("cancel");
          vm.showError("Failed to remove workplace!");
        });
    },
    showError(error) {
      this.$eventHub.$emit("addAlert", { type: "error", message: error });
    },
    showUpdated() {
      this.showFlash("Workplace successfully saved!");
    },
    showRemoved() {
      this.showFlash("Workplace successfully removed!");
    },
    showFlash(message) {
      this.$eventHub.$emit("addAlert", { type: "success", message: message });
    },
  },
};
</script>
